import React from "react";
import classNames from "classnames";
import { TeamGoalStats } from "@data-types/sport-stats/SportStatsTypes";
import { StatGrid } from "./StatGrid";

export const TeamStats = ({
	teamData,
	label,
	type,
	className,
}: {
	teamData: TeamGoalStats;
	label: string;
	type: "Scored" | "Conceded";
	className?: string;
}) => {
	return (
		<tr className={classNames("table__body__tr table__row", className)}>
			<td className="table__body__cell table__cell table__cell--xtny u-type--left">
				{label}
			</td>

			<td
				className={classNames(
					"table__body__cell table__cell table__cell--xtny u-type--wgt--medium u-type--right",
					{
						"u-color--sent--success": type === "Scored",
						"u-color--sent--danger": type !== "Scored",
					}
				)}
			>
				{type === "Scored"
					? teamData.scoredGoals
					: teamData.concededGoals}
			</td>

			<StatGrid
				periods={teamData.periods}
				statKey={type === "Scored" ? "scoredGoals" : "concededGoals"}
			/>
		</tr>
	);
};
